import React from "react";
import {Column, useTable} from "react-table";
import {NoDataMessage} from "./NoDataMessage";

interface TableProps<D extends object> {
  tableData: D[];
  columns: Column<D>[];
}

export const Table = <ColumnType extends object>(props : TableProps<ColumnType>) => {
  const {tableData, columns} = props;

  const tableInstance = useTable(
    {
      columns,
      data: tableData,
    },
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
  } = tableInstance;

  return (
    <>
      <div className="overflow-x-scroll whitespace-nowrap block">
        { /* eslint-disable-next-line react/jsx-props-no-spreading */ }
        <table {...getTableProps({
          className: "table-auto border-separate w-full"
        })}>
          <thead className="bg-primary text-white text-xs w-full">
          {
            headerGroups.map(headerGroup => (
              // eslint-disable-next-line react/jsx-props-no-spreading,react/jsx-key
              <tr {...headerGroup.getHeaderGroupProps()}>
                {
                  headerGroup.headers.map(column => (
                    // eslint-disable-next-line react/jsx-props-no-spreading,react/jsx-key
                    <th className='py-1 px-2 select-none' {...column.getHeaderProps()}>
                        {column.render('Header')}
                    </th>
                  ))}
              </tr>
            ))}
          </thead>
          { /* eslint-disable-next-line react/jsx-props-no-spreading */ }
          <tbody {...getTableBodyProps({
            className: "bg-white text-sm"
          })}>
          {
            rows.map(row => {
              prepareRow(row)
              return (
                // eslint-disable-next-line react/jsx-props-no-spreading,react/jsx-key
                <tr {...row.getRowProps()}>
                  {
                    row.cells.map(cell => {
                      return (
                        // eslint-disable-next-line react/jsx-props-no-spreading,react/jsx-key
                        <td {...cell.getCellProps({
                          className: "p-4 font-medium whitespace-normal"
                        })} >
                          {// Render the cell contents
                            cell.render('Cell')}
                        </td>
                      )
                    })}
                </tr>
              )
            })}
          </tbody>
        </table>
        { tableData.length === 0 && (
          <div className="mt-6">
            <NoDataMessage />
          </div>
        )}
      </div>
    </>
  );
};
